import React from "react";
import Orders from "shared/containers/Orders/Orders";
import { useIsMobile } from "shared/hooks/useIsMobile";

export default function OrdersPage() {
  const isMobile = useIsMobile();
  return <Orders isMobile={isMobile} />;
}
